//COMMON
// import 'intersection-observer';
import './common';
import './vendors/setHeightHtml'

//SASS - COMMON
import '../sass/main.scss';

import myLazyLoad from './vendors/lazyLoading';

// import customSelect from 'custom-select';
// import Scrollbar from 'smooth-scrollbar';

myLazyLoad.update();

document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', function (e) {
    e.preventDefault();
    var href = this.getAttribute("href");
    var elem = document.querySelector(href) || document.querySelector("a[name=" + href.substring(1, href.length) + "]");
    window.scroll({
      top: elem.offsetTop - 120,
      left: 0,
      behavior: 'smooth'
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var lazyBackgrounds = [].slice.call(document.querySelectorAll(".lazy-background"));

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function (lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const header = document.getElementById("headerHolder");
  const menuToggle = document.getElementById("menu-toggle");
  const menuClose = document.getElementById("menu-close");
  const menuSocials = document.getElementById("menu-socials");
  const menu = document.getElementById("menu");

  // Efekt sticky po przewinięciu
  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }
  });

  // Obsługa menu klawiaturą i myszą
  menuToggle.addEventListener("click", function () {
    // setTimeout(() => {
      menuClose.classList.add("active");
      menuSocials.classList.add("active");
    // }, 400)
    menu.classList.add("open");
    menuClose.focus();

  });

  menuClose.addEventListener("click", function () {
    menuClose.classList.remove("active");
    menuSocials.classList.remove("active");
    menu.classList.remove("open");
    menuToggle.focus();

  });

  // Zamknięcie menu klawiszem ESC
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && menu.classList.contains("open")) {
      menu.classList.remove("open");
      menuToggle.focus();
    }
  });
});